import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        {/* Section Header */}
        <div className="flex flex-col items-center text-center mb-12">
          <span className="text-foreground-400 font-label text-xs tracking-widest uppercase mb-3">
            独家深扒
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            分类吃瓜
          </h2>
          <p className="text-foreground-500 text-sm max-w-md">
            按你的口味挑选，每一口瓜都保熟保甜
          </p>
        </div>

        {/* Category Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {categories.map((cat, idx) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`group relative rounded-2xl overflow-hidden h-[320px] cursor-pointer ${
                idx === 0 ? 'md:mt-0' : idx === 1 ? 'md:mt-6' : 'md:mt-12'
              }`}
            >
              {/* Background Image */}
              <img
                src={cat.coverImage}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                {/* Category Tag */}
                <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs mb-3">
                  <i className={`${cat.icon} text-sm`}></i>
                  <span>{cat.name}</span>
                </div>

                {/* Category Name */}
                <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-2">
                  {cat.name}
                </h3>

                {/* Description */}
                <p className="text-background-200/80 text-xs leading-relaxed line-clamp-2">
                  {cat.description}
                </p>

                {/* Arrow */}
                <div className="mt-4 flex items-center gap-1.5 text-background-50/70 text-xs group-hover:text-background-50 transition-colors">
                  <span>浏览全部</span>
                  <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}